"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nBundleNames = exports.i18nLocaleToLangMap = exports.i18n = exports.i18nPreferred = exports.i18nPathToBundleMap = void 0;
// Maps application path to bundle names
exports.i18nPathToBundleMap = {
    ar: 'ar_SA',
    de: 'de_DE',
    en: 'en_US',
    es: 'es_ES',
    fr: 'fr_FR',
    id: 'id_ID',
    it: 'it_IT',
    ja: 'ja_JP',
    ko: 'ko_KR',
    nl: 'nl_NL',
    pl: 'pl_PL',
    pt: 'pt_BR',
    ro: 'ro_RO',
    ru: 'ru_RU',
    ta: 'ta_IN',
    th: 'th_TH',
    tr: 'tr_TR',
    vi: 'vi_VN',
    xa: 'xa_PL',
    xb: 'xb_LW',
    xc: 'xc_LT',
    'zh-cn': 'zh_CN',
    'zh-tw': 'zh_TW',
};
exports.i18nPreferred = ['en'];
exports.i18n = {
    locales: Object.keys(exports.i18nPathToBundleMap),
    defaultLocale: 'en',
};
exports.i18nLocaleToLangMap = (() => {
    const map = {};
    exports.i18n.locales.forEach((lang) => {
        map[exports.i18nPathToBundleMap[lang]] =
            lang;
    });
    return map;
})();
exports.i18nBundleNames = Object.values(exports.i18nPathToBundleMap);
//# sourceMappingURL=next.config.i18n.js.map